// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import { IconButton } from '../buttons';
import { UnitInput } from '../inputs';
import { Tooltip } from '../tooltips';

// Utils
import { formatLocalizedString } from '../../../utils/i18n';
import BMOGIFPortfolioHolding from '@/types/bmo-gif/bmo-gif-portfolio-holding';

type Props = {
  portfolioHolding: BMOGIFPortfolioHolding;
  onWeightChange: (id: string, value: number) => void;
  onRemoveHolding: (holding: BMOGIFPortfolioHolding) => void;
  readOnly?: boolean;
  customTemplate?: boolean;
};

const EditBMOGIFPortfolioHolding: React.FC<Props> = ({ portfolioHolding, onWeightChange, onRemoveHolding, readOnly, customTemplate }) => {
  const handleWeightChange = (holding: BMOGIFPortfolioHolding, weight: number) => {
    const newWeight = Math.max(0, Math.min(100, weight));
    onWeightChange(holding.id, Math.round(newWeight * 1000000) / 1000000);
  };

  const holdingName = formatLocalizedString(portfolioHolding.name);
  const holdingSymbol = portfolioHolding.symbol;

  return (
    <div className={classNames('bmo-gif-portfolio-holding-v2 d-flex align-items-center')}>
      <div className="bmo-gif-portfolio-holding-v2-field">
        <div className="bmo-gif-portfolio-holding-v2-name d-flex">
          <span className="bmo-gif-portfolio-holding-v2-symbol">{holdingSymbol}</span>
          <Tooltip message={holdingName} delayShow={300}>
            <span data-private data-dd-privacy="mask">
              {holdingName}
            </span>
          </Tooltip>
        </div>

        <div className="bmo-gif-portfolio-holding-v2-actions">
          <div className="bmo-gif-portfolio-holding-v2-field column">
            <UnitInput
              className="unit-input-v2"
              type="number"
              unitSymbol="%"
              disabled={readOnly || !customTemplate}
              min={0}
              value={portfolioHolding.weight || ''}
              onValueChange={(value: string) => handleWeightChange(portfolioHolding, Number(value))}
              onClick={event => event.stopPropagation()}
            />
          </div>

          <div className="bmo-gif-portfolio-holding-v2-field column delete">
            {!readOnly && customTemplate && <IconButton icon="ds-delete" onClick={() => onRemoveHolding(portfolioHolding)} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditBMOGIFPortfolioHolding;
